<div class="tabs sticky" ngClass.gt-xs="tabs__desktop">
    <!--    <img-->
    <!--        fxLayout-->
    <!--        fxHide.gt-xs-->
    <!--        style="cursor: pointer; margin: 0 0 17px 17px;"-->
    <!--        class="icon"-->
    <!--        (click)="backButton()"-->
    <!--        src="https://images.dailyobjects.com/icons/arrow.png"-->
    <!--    />-->
    <filter-shimmer
        [ghosts]="ghostFilter"
        fxLayout="row"
        *ngIf="pageData?.feed.length === 0"
    ></filter-shimmer>
    <div
        style="position: absolute; right: 0%; z-index: 3"
        (click)="processLink(pageData?.cross.link)"
        (click)="closeDialog()"
    >
        <img
            class="cross-icn"
            (click)="processLink(pageData?.cross.link)"
            (click)="closeDialog()"
            src="https://images.dailyobjects.com/icons/cross.png"
            style="width: 20px; cursor: pointer"
        />
    </div>
    <mat-tab-group
        [selectedIndex]="pageData?.active || 0"
        *ngIf="pageData?.feed"
        [ngClass.gt-xs]="{
            'desktop-tab': true,
            'left-aligned-header-desktop': asHTMLTag
        }"
    >
        <mat-tab *ngFor="let item of pageData?.feed">
            <ng-template mat-tab-label>
                <a class="tab-header" (click)="processLink(item)"
                    >{{ item?.text }}
                </a>
            </ng-template>
            <ng-template matTabContent>
                <div
                    fxLayout="column"
                    fxLayoutAlign="space-between"
                    class="tab-content"
                    *ngFor="let feed of item?.feed"
                >
                    <p *ngIf="!!feed?.text">{{ feed?.text }}</p>

                    <app-search-style-container
                        *ngIf="feed?.layout === 'circle'"
                        (processLink)="processLink($event)"
                        [styles]="feed?.feed"
                        class="listing-styles-item"
                        [padding]="0"
                        [scrolling]="'vertical'"
                    ></app-search-style-container>
                    <div *ngIf="feed?.layout === 'list'">
                        <div
                            [ngStyle]="{
                                marginBottom: !!feed?.image ? '20px' : '0'
                            }"
                            *ngFor="let feed of feed?.feed"
                            fxLayout="row"
                            fxLayoutGap="40px"
                        >
                            <app-search-style-item
                                *ngIf="!!feed?.image"
                                (processLink)="processLink($event)"
                                [style]="feed"
                                [hideTitle]="true"
                            >
                            </app-search-style-item>
                            <p
                                (click)="processLink(feed?.link)"
                                style="
                                    font-size: 16px;
                                    font-weight: normal;
                                    cursor: pointer;
                                    font-family: 'Roboto Regular', sans-serif;
                                "
                                [ngStyle]="{
                                    color:
                                        feed?.active === true ? '#20a87e' : ''
                                }"
                            >
                                {{ feed?.title?.text }}
                            </p>
                        </div>
                    </div>
                    <hr class="filter-separator" />
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <a class="tab-header">Sort</a>
            </ng-template>
            <ng-template matTabContent>
                <div ngStyle.xs="width: 100vw;">
                    <div
                        *ngFor="let item of sortingOption; let i = index"
                        style="margin-bottom: 40px; margin-top: 16px"
                    >
                        <a
                            [ngClass]="{
                                active: item.title?.text === selectedSort
                            }"
                            (click)="onActive(i)"
                            (click)="processLink(item.link)"
                            style="cursor: pointer"
                            (click)="closeDialog()"
                        >
                            {{ item.title?.text }}
                        </a>
                    </div>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
    <div
        class="apply-reset"
        [ngClass.gt-xs]="{ 'apply-reset-gt-xs': 'true' }"
        ngClass.xs="apply-reset-mobile"
        fxLayout
        fxLayoutAlign.gt-xs="space-between"
        fxLayoutAlign.xs="space-between"
    >
        <button
            fxHide.gt-xs
            mat-button
            class="action-button-underline"
            (click)="processLink(pageData?.leftButton?.link)"
        >
            {{ pageData?.leftButton?.text }}
        </button>
        <button
            class="action-button-underline"
            color="black"
            (click)="sortReset()"
            (click)="closeDialog()"
            (click)="
                processLink(pageData?.rightButton?.link || this.rightButtonLInk)
            "
            mat-button
        >
            {{ pageData?.rightButton?.text }}
        </button>
    </div>
</div>
